import React from 'react';
import musicPlayerStore from '../../stores/musicPlayer';
import playerStore from '../../stores/player';

function HiddenEvents() {

  const isPlaying = musicPlayerStore((state) => state.isPlaying);
  const isMusicOn = musicPlayerStore((state) => state.isMusicOn);
  const isPaused = musicPlayerStore((state) => state.isPaused);
  const currentVolume = musicPlayerStore((state) => state.currentVolume);
  const isPlayerStopped = playerStore((state) => state.isStopped);

  const getPlayerState = () => {
    if(!isMusicOn){
      return "stopped"
    }
    if (isPlayerStopped.isStopped) {
      if (isPaused.isPaused) {
        return "paused"
      }else{
        return "playing"
      } 
    } else {
      if (isPaused.isPaused) {
        return "paused"
      }else{
        return "waiting"
      }
    }
  };

  const getVolume = () => {
    if(currentVolume){
      if(currentVolume.currentVolume){
        return Math.round(currentVolume.currentVolume*100);
      }
    }
  }

  return (
    <div id="muvika-background-music-player-hidden-info">
      <div id="muvika-background-music-player-state">{getPlayerState()}</div>
      <div id="muvika-background-music-player-volume">{getVolume()}</div>
    </div>
  );
}

export default HiddenEvents;